import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentService } from 'src/app/services/payment.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { SharedService } from 'src/app/services/shared.service';
import { Utility } from 'src/app/core/common';
import { AccountingService } from 'src/app/services/accounting.service';
import { PaymentStatus } from 'src/app/common';

@Component({
  selector: 'app-manage-payments',
  templateUrl: './manage-payments.component.html',
  styleUrls: ['./manage-payments.component.scss']
})
export class ManagePaymentsComponent implements OnInit, OnDestroy {
  constructor(private route: ActivatedRoute, private router: Router, private paymentService: PaymentService,
    private spinner: SpinnerService, private sharedService: SharedService, private accountingService: AccountingService) { }
  PaymentStatus = PaymentStatus;

  day = 24 * 60 * 60 * 1000;
  criteria: any = { status: PaymentStatus.Link, type: 0, provider: -1, limit: 100 };
  payments: any[];
  total: number;
  records: any[];

  async ngOnInit() {
    if (!this.sharedService.isBrowser)
      return;
    this.route.queryParams.pipe(switchMap(async criteria => {
      this.criteria = Utility.assign(this.criteria, criteria);
      await this.load();
    }))
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe();
  }

  private unsubscribe$ = new Subject<void>();
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  async load() {
    this.spinner.show();
    const result = await this.paymentService.search({
      Keyword: this.criteria.q,
      Statuses: (this.criteria.status == null || this.criteria.status == PaymentStatus.Link) ? undefined : [+this.criteria.status],
      Provider: this.criteria.provider,
      CreateTime: [new Date(this.criteria.time_from), new Date(this.criteria.time_to)].map(_ => isNaN(<any>_) ? null : _)
    }, this.criteria.from, this.criteria.limit);
    this.payments = result.payments;
    this.total = result.total;

    var records = await this.accountingService.list(false, false, 0, 100);
    this.records = records.records;

    this.spinner.hide();
  }

  async verifyLink(payment: any, succeed?: boolean) {
    const link = await this.paymentService.verifyManual(payment.Id, payment.RefId, succeed);
    payment._verifyLink = link;
    payment.Status = succeed ? PaymentStatus.Completed : PaymentStatus.Failed;
  }

  navigate(key?: string, value?: string) {
    this.criteria.from = 0;
    if (key) { this.criteria[key] = value; }
    this.router.navigate([], { queryParams: this.criteria, queryParamsHandling: 'merge', relativeTo: this.route });
  }

  async loadManual() {
    this.criteria.provider = 4;
    this.criteria.status = PaymentStatus.Pending;
    await this.load();
  }

  async changeAmount(paymentId: string, amount: number) {
    await this.paymentService.changeAmount(paymentId, amount);
    await this.load();
  }
}
